import React, { useContext, useState } from 'react';
import axios from 'axios';
import ENDPOINT from '../../context/EndPoint';
import { AuthContext } from '../../context/AuthContext';
import { Close } from '@material-ui/icons';
import DefaultModal from '../../components/modals/DefaultModal';

const EditLeadModal = ({ visibility, handleClose, item, Reload }) => {
  const [currentid, setCurrentid] = useState(null);
  const [leadname, setLeadname] = useState(item.name);
  const [lemail, setLemail] = useState(item.email);
  const [lphone, setLphone] = useState(item.phone);
  const [lwhatsapp, setLwhatsapp] = useState(item.whatsapp);
  const [lnote, setLnote] = useState(item.note);
  const [lstatus, setLstatus] = useState(item.status);
  const [lcategory, setLcategory] = useState(item.category);
  const [saveStatus, setSaveStatus] = useState('Save Changes'); // State for button text

  const [initialData, setInitialData] = useState([]);
  const [response, setResponse] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const { user } = useContext(AuthContext);

  const EditLead = async () => {
    if (user !== null) {
      setSaveStatus('Saving...'); // Set button text to "Saving..."
      const data = new FormData();
      data.append("name", leadname);
      data.append("email", lemail);
      data.append("phone", lphone);
      data.append("whatsapp", lwhatsapp);
      data.append("category", lcategory);
      data.append("note", lnote);
      data.append("id", item.id);
      data.append("session", user.SessionId);

      try {
        const res = await axios.post(ENDPOINT + "admin-edit-lead.php", data, {
          headers: { "content-type": "multipart/form-data" },
        });
        if (res.data.status === "success") {
          setSaveStatus('Saved'); // Set button text to "Saved"
          Reload(); // Refresh leads data
          setTimeout(() => {
            handleClose(); // Close the modal after a 1-second delay
          }, 1000);
        } else {
          setSaveStatus('Save Changes'); // Revert to original text on failure
          console.error("Update failed:", res.data.message);
        }
      } catch (err) {
        setSaveStatus('Save Changes'); // Revert to original text on error
        console.error("Error updating lead:", err.message);
      }
    }
  };

  return (
    <DefaultModal
      content={
        <div className="p-2">
          <div className="flex justify-content-between">
            <h4>Edit Lead</h4>
            <Close type="button" onClick={handleClose} />
          </div>
          <hr />

          <div className="d-flex">
            <div>
              <h6>Name</h6>
              <input
                className="form-control"
                placeholder="name"
                onChange={(e) => setLeadname(e.target.value)}
                value={leadname}
                minLength={4}
              />
            </div>
            <div>
              <h6>Email</h6>
              <input
                className="form-control"
                placeholder="email"
                onChange={(e) => setLemail(e.target.value)}
                value={lemail}
                minLength={10}
                maxLength={100}
              />
            </div>
          </div>

          <div className="d-flex mt-3">
            <div>
              <h6>Phone</h6>
              <input
                className="form-control"
                placeholder="phone"
                onChange={(e) => setLphone(e.target.value)}
                value={lphone}
                minLength={10}
                maxLength={12}
              />
            </div>
            <div>
              <h6>Whatsapp</h6>
              <input
                className="form-control"
                placeholder="whatsapp"
                onChange={(e) => setLwhatsapp(e.target.value)}
                value={lwhatsapp}
                minLength={10}
                maxLength={12}
              />
            </div>
          </div>

          <div className="d-flex mt-3">
            <div>
              <h6>Category</h6>
              <select
                className="form-control"
                onChange={(e) => setLcategory(e.target.value)}
                value={lcategory}
              >
                <option value="Interested to join course">Interested to join course</option>
                <option value="General Query">General query</option>
                <option value="Workshop query">Workshop query</option>
                <option value="Others">Others</option>
              </select>
            </div>
            <div>
              <h6>Status</h6>
              <select
                className="form-control"
                onChange={(e) => setLstatus(e.target.value)}
                value={lstatus}
              >
                <option value="interested">Interested</option>
                <option value="demo_scheduled">Demo Scheduled</option>
                <option value="pending_payment">Pending Payment</option>
                <option value="joined">Joined Course</option>
                <option value="not_interested">Not interested</option>
              </select>
            </div>
          </div>

          <div className="">
            <h6>Note</h6>
            <textarea
              className="form-control"
              placeholder="note"
              value={lnote}
              onChange={(e) => setLnote(e.target.value)}
              maxLength={300}
            />
          </div>

          <button
            onClick={EditLead}
            className="btn btn-primary w-100 mt-3"
            disabled={saveStatus === 'Saving...'}
          >
            {saveStatus}
          </button>
        </div>
      }
      show={visibility}
      handleClose={handleClose}
    />
  );
};

export default EditLeadModal;